import { IMAGE_RESIZE_SPEC } from '@core/image'
import { Cover, Skeleton } from '@ds/components'

import styles from './CollectionMiniCardSkeleton.module.css'

export const CollectionMiniCardSkeleton = () => (
    <div className={styles.card}>
        <div className={styles.coverBox}>
            <Cover
                stacked
                shouldScale={false}
                src=""
                alt=""
                sizes="60px"
                className={styles.coverImage}
                resize={IMAGE_RESIZE_SPEC}
            />
        </div>
        <div className={styles.main}>
            <Skeleton className={styles.title} />
            <Skeleton className={styles.author} />
        </div>
    </div>
)
